import { render, staticRenderFns } from "./NexusSyncReport.vue?vue&type=template&id=bd1de628&"
import script from "./NexusSyncReport.vue?vue&type=script&lang=js&"
export * from "./NexusSyncReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports